import React from 'react';

const map = {
  scheduled: 'so-pill so-pill-neutral',
  pending: 'so-pill so-pill-warning',
  confirmed: 'so-pill so-pill-success',
  cancelled: 'so-pill so-pill-danger',
  completed: 'so-pill so-pill-success',
  no_show:   'so-pill so-pill-danger',
  open: 'so-pill so-pill-neutral',
  notified: 'so-pill so-pill-warning',
  filled: 'so-pill so-pill-success',
  expired: 'so-pill so-pill-danger',
  active: 'so-pill so-pill-success',
  deleted: 'so-pill so-pill-neutral',
};

export default function StatusPill({ status, label }) {
  return <span className={map[status] || 'so-pill so-pill-neutral'} data-testid={`status-${status}`}>{label || status}</span>;
}
